import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class ResetPasswordMetaModel extends FormMetaModel {
    constructor() {
        super('ResetPassword', ROUTE_PATH.resetPassword , ROUTE_PATH.login, 1);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const email = new SmMetaInputModel(
            'email',
            'email',
            'input',
            true,
            'form-control col-12 ',
            1,
            1,
            'Email ID',
            'text',
            '',
            false,
            true,
            true,
            false,
            50,
            5,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            "",
            "",
            false,
            [],
            false,
            "",
            false,
            true,
            false,
            true
        );
        
        const temppassword = new SmMetaInputModel(
            'temppassword',
            'temppassword',
            'input',
            true,
            'form-control col-12 ',
            1,
            1,
            'OTP',
            'text',
            '',
            false,
            true,
            true,
            false,
            50,
            5,
            
        );
        const newpassword = new SmMetaInputModel(
            'newpassword',
            'newpassword',
            'input',
            true,
            'input-fg form-group col-6 col-md-6',
            1,
            1,
            'New Password',
            'password',
            '',
            false,
            true,
            true,
            false,
            40,
            4,
            
        );
        const confirmpassword = new SmMetaInputModel(
            'confirmpassword',
            'confirmpassword',
            'input',
            true,
            'input-fg form-group col-6 col-md-6',
            1,
            1,
            'Confirm Password',
            'password',
            '',
            false,
            true,
            true,
            false,
            40,
            4,
            
        );
        

        const Submit = new SmBtnMetaModel('Change Password', 'primary', true, false, true, false);

        return {
            formInfo,
            email,
            temppassword,
            newpassword,
            confirmpassword,
            Submit
        };
    }
}